import { render, staticRenderFns } from "./new-transaction-popup.vue?vue&type=template&id=7d7a0627&"
import script from "./new-transaction-popup.vue?vue&type=script&lang=js&"
export * from "./new-transaction-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports